import { render, staticRenderFns } from "./chongMsg.vue?vue&type=template&id=6a89db07&scoped=true"
import script from "./chongMsg.vue?vue&type=script&lang=js"
export * from "./chongMsg.vue?vue&type=script&lang=js"
import style0 from "./chongMsg.vue?vue&type=style&index=0&id=6a89db07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89db07",
  null
  
)

export default component.exports